import type { HttpDelete } from '@/shared/infra/http'
import type { DeleteChannel } from '@/modules/connect/use-cases'
import { mapChannelAdminError } from './map-channel-admin-error'

export class EdgeDeleteChannelRepository {
  constructor(private readonly http: HttpDelete) {}

  execute: DeleteChannel = async (params) => {
    const query = `?orgId=${encodeURIComponent(params.orgId)}&orgType=${params.orgType}`
    try {
      await this.http.delete<unknown>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}${query}`,
      })
    } catch (err) {
      throw mapChannelAdminError(err)
    }
  }
}
